export default "__VITE_ASSET__d12b6d45__"